import { ThemeEvents, VariantUpdateEvent } from '@theme/events';

/**
 * A custom element that displays dropship information.
 * This component listens for variant update events and updates the dropship display accordingly.
 * It checks if the variant has a dropship metafield and if the current country is not in the allowed list.
 */
class ProductDropship extends HTMLElement {
  connectedCallback() {
    const closestSection = this.closest('.shopify-section, dialog');
    if (!closestSection) return;
    closestSection.addEventListener(ThemeEvents.variantUpdate, this.updateDropship);
  }

  disconnectedCallback() {
    const closestSection = this.closest('.shopify-section, dialog');
    if (!closestSection) return;
    closestSection.removeEventListener(ThemeEvents.variantUpdate, this.updateDropship);
  }

  /**
   * Updates the dropship display based on variant changes.
   * @param {VariantUpdateEvent} event - The variant update event.
   */
  updateDropship = (event) => {
    if (event.detail.data.newProduct) {
      this.dataset.productId = event.detail.data.newProduct.id;
    } else if (event.target instanceof HTMLElement && event.target.dataset.productId !== this.dataset.productId) {
      return;
    }

    // Look for dropship component in the new HTML
    const newDropshipComponent = event.detail.data.html.querySelector('product-dropship');
    const newDropship = newDropshipComponent?.querySelector('[ref="dropshipContainer"]');
    const currentDropship = this.querySelector('[ref="dropshipContainer"]');

    if (!newDropship || !newDropshipComponent) {
      // Hide if no dropship content in new variant
      this.hidden = true;
      return;
    }

    // Show the component
    this.hidden = false;

    if (!currentDropship) {
      // If no current content, append the new one
      this.appendChild(newDropship);
    } else {
      // Update content if it changed
      if (currentDropship.innerHTML !== newDropship.innerHTML) {
        currentDropship.replaceWith(newDropship);
      }
    }

    // Update variant ID and allowed countries if changed
    if (newDropshipComponent.dataset.variantId) {
      this.dataset.variantId = newDropshipComponent.dataset.variantId;
    }
    if (newDropshipComponent.dataset.allowedCountries) {
      this.dataset.allowedCountries = newDropshipComponent.dataset.allowedCountries;
    }
  };
}

if (!customElements.get('product-dropship')) {
  customElements.define('product-dropship', ProductDropship);
}
